   
    import { PerfilConfig } from "@/core/config/PerfisConfig"; 
    import   SiteUtils   from '@/assets/ts/aplicacao/site'; 
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
	import $ from "jquery"  
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options , Vue } from "vue-class-component";   
    import {  Prop  , Watch } from 'vue-property-decorator';   
    @Options({
        name: "EditarMatricula",
        components: {  CardRh, BotaoSalvar },   
        emits: [  'dados-matricula-alterado'],  

    }) 
    export default class EditarMatricula extends Vue { 
        
        @Prop( ) readonly matricula!: any  
        @Prop( ) readonly service!: any   
        @Prop( ) readonly perfis!: any  
        
        public identificador = 1 ;   
        public numeroCurso: any = null ; 
        public isPendAcadSaude: any = null ; 
        public isLiminar: any = null ; 
        public isPendAcadProc: any = null ; 
        public isRemanescente: any = null ; 
        public pelotao: any = null ;
        public processoLiminar: any = null ;
        public dataAprovado: any = null ;
        public docPublicacao: any = null ;
        public dataPublicacao: any = null ;
        public mediaFinal: any = null ; 
        public observacao: any = null ; 
        public modal: any = "modal_matricula_editar" ;
        public processando = false ;

        @Watch('matricula')
		dadosAtualizado(newVal: string) { 
            this.identificador++; 
		} 
         
        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }
  
        public iniciar() { 
            this.processoLiminar = this.matricula.processoLiminar; 
            this.pelotao = this.matricula.pelotao; 
            this.numeroCurso = this.matricula.numeroCurso;  
            this.isPendAcadSaude = this.matricula.isPendAcadSaude;  
            this.isLiminar = this.matricula.isLiminar;  
            this.isPendAcadProc = this.matricula.isPendAcadProc;  
            this.isRemanescente = this.matricula.isRemanescente;  
            this.mediaFinal = this.matricula.mediaFinal; 
            this.dataAprovado = SiteUtils.formatDataToPadrao( this.matricula.dataAprovado ); 
            this.docPublicacao = this.matricula.docPublicacao; 
            this.dataPublicacao =  SiteUtils.formatDataToPadrao(this.matricula.dataPublicacao); 
            this.identificador++; 
        }

        
        public AlterarMatricula() {
            if( this.processando  ||  !this.hasPermissao ){
                return;
            }
            this.processando = true ;
            let dados: any = {};
            if(this.matricula.status.id == 6){
                dados = {
                    id: this.matricula.id,
                    mediaFinal: this.mediaFinal,
                    dataAprovado: this.dataAprovado,
                    docPublicacao: this.docPublicacao,
                    dataPublicacao: this.dataPublicacao,
                }
            } 
            else{
                dados = {
                    id: this.matricula.id,
                    pelotao: this.pelotao,
                    processoLiminar: this.processoLiminar,
                    numeroCurso: this.numeroCurso, 
                    isPendAcadSaude: this.isPendAcadSaude, 
                    isLiminar: this.isLiminar, 
                    isPendAcadProc: this.isPendAcadProc,  
                    isRemanescente: this.isRemanescente,  
                }
                if( this.matricula.isLiminar != this.isLiminar || this.matricula.isPendAcadSaude != this.isPendAcadSaude || this.matricula.isPendAcadProc != this.isPendAcadProc){
                    dados.observacao = this.observacao
                }
            } 
            this.service.alterarSimples( this.matricula.id , dados )
            .then(response => { 
                this.$emit("dados-matricula-alterado", response);
                this.processando = false ;
                $("[data-bs-dismiss='modal']").trigger({ type: "click" });
            })
            .catch(errors => {
                this.processando = false ;
            });
        }


    } 
